import React from 'react';

import { ReportTemplate } from 'api/endPoints/GetReportTemplateList';

import { Button } from 'components/DesignSystem/Button';
import { Modal } from 'components/DesignSystem/Modal';
import { EditReportTemplateForm } from 'components/widgets/ReportsHome/ReportsTemplates/components/EditReportTemplateModal/EditReportTemplateForm/EditReportTemplateForm';
import { useEditReportTemplateModalLogic } from 'components/widgets/ReportsHome/ReportsTemplates/components/EditReportTemplateModal/EditReportTemplateModal.Logic';
import { useEditReportTemplateModalProvider } from 'components/widgets/ReportsHome/ReportsTemplates/components/EditReportTemplateModal/EditReportTemplateModal.provider';

const MODAL_WIDTH = 720;

interface Props {
    isShowModal: boolean;
    closeModal: () => void;
    template: ReportTemplate | null;
}

export const EditReportTemplateModal = ({ isShowModal, closeModal, template }: Props) => {
    const { api } = useEditReportTemplateModalProvider();
    const { logic } = useEditReportTemplateModalLogic({ template, closeModal, api });

    return (
        <Modal
            width={MODAL_WIDTH}
            open={isShowModal}
            onClose={() => closeModal()}
            title={`Edit the "${template?.name ?? ''}" Template`}
            actions={
                <>
                    <Button
                        size={'large'}
                        variant={'secondary'}
                        onClick={() => {
                            closeModal();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        size={'large'}
                        variant={'primary'}
                        isLoading={api.editReportTemplate.instance.isLoading}
                        onClick={logic.form.handleSubmit(logic.handleSubmitForm)}
                        disabled={!logic.form.formState.isDirty}
                    >
                        Update Template
                    </Button>
                </>
            }
        >
            <EditReportTemplateForm logic={logic} />
        </Modal>
    );
};
